import React from "react";
import { Text as ReactText } from "react-native";

import tw from "../styles/tailwind";


export default function Text(props) {
  const style = {
    fontFamily: "Poppins_400Regular"
  }

  // if (props.children == "Cuotas") {
  //   // style.fontFamily = "Poppins_700Bold"
  //   // props.style.fontWeight = "700"
  //   // props.style = {}
  //   console.log("✅ Cuotas >>>", props.style, style);
  // }

  const propsStyle = {
    ...props.style
  }

  if (props.style?.fontWeight == "thin" || props.style?.fontWeight == "100") {
    // propsStyle.fontWeight = "100"
    propsStyle.fontWeight = null
    style.fontFamily = "Poppins_100Thin"
  }
  else if (props.style?.fontWeight == "extra-light" || props.style?.fontWeight == "200") {
    // propsStyle.fontWeight = "200"
    propsStyle.fontWeight = null
    style.fontFamily = "Poppins_200ExtraLight"
  }
  else if (props.style?.fontWeight == "light" || props.style?.fontWeight == "300") {
    // propsStyle.fontWeight = "300"
    propsStyle.fontWeight = null
    style.fontFamily = "Poppins_300Light"
  }
  else if (props.style?.fontWeight == "regular" || props.style?.fontWeight == "400") {
    // propsStyle.fontWeight = "400"
    propsStyle.fontWeight = null
    style.fontFamily = "Poppins_400Regular"
  }
  else if (props.style?.fontWeight == "medium" || props.style?.fontWeight == "500") {
    propsStyle.fontWeight = null
    style.fontFamily = "Poppins_500Medium"
  }
  else if (props.style?.fontWeight == "semi-bold" || props.style?.fontWeight == "600") {
    propsStyle.fontWeight = null
    style.fontFamily = "Poppins_600SemiBold"
  }
  else if (props.style?.fontWeight == "bold" || props.style?.fontWeight == "700") {
    // if (props.children == "Cuotas") {
    //   console.log("✅✅ Cuotas Pre >>>", props.style, propsStyle, style);
    // }

    propsStyle.fontWeight = null

    // if (props.children == "Cuotas") {
    //   console.log("🌔 Cuotas after >>>", props.style, propsStyle, style);
    // }

    style.fontFamily = "Poppins_700Bold"
  }
  
  else if (props.style?.fontWeight == "extra-bold" || props.style?.fontWeight == "800") {
    // propsStyle.fontWeight = "800"
    propsStyle.fontWeight = null
    style.fontFamily = "Poppins_800ExtraBold"
  }
  else if (props.style?.fontWeight == "black") {
    // propsStyle.fontWeight = "900"
    propsStyle.fontWeight = null
    style.fontFamily = "Poppins_900Black"
  }
  // else if (props.style?.fontWeight == "thin-italic") {
  //   props.style.fontWeight = "100"
  //   style.fontFamily = "Poppins_100Thin_Italic"
  // }
  // else if (props.style?.fontWeight == "extra-light-italic") {
  //   props.style.fontWeight = "200"
  //   style.fontFamily = "Poppins_200ExtraLight_Italic"
  // }
  // else if (props.style?.fontWeight == "light-italic") {
  //   props.style.fontWeight = "300"
  //   style.fontFamily = "Poppins_300Light_Italic"
  // }
  // else if (props.style?.fontWeight == "italic") {
  //   props.style.fontWeight = "400"
  //   style.fontFamily = "Poppins_400Regular_Italic"
  // }
  // else if (props.style?.fontWeight == "medium-italic") {
  //   props.style.fontWeight = "500"
  //   style.fontFamily = "Poppins_500Medium_Italic"
  // }
  // else if (props.style?.fontWeight == "semi-bold-italic") {
  //   props.style.fontWeight = "600"
  //   style.fontFamily = "Poppins_600SemiBold_Italic"
  // }
  // else if (props.style?.fontWeight == "bold-italic") {
  //   props.style.fontWeight = "700"
  //   style.fontFamily = "Poppins_700Bold_Italic"
  // }
  // else if (props.style?.fontWeight == "extra-bold-italic") {
  //   props.style.fontWeight = "800"
  //   style.fontFamily = "Poppins_800ExtraBold_Italic"
  // }
  // else if (props.style?.fontWeight == "black-italic") {
  //   props.style.fontWeight = "900"
  //   style.fontFamily = "Poppins_900Black_Italic"
  // }

  // if(props.children == "Cuotas"){
  //   console.log("Cuotas ====", props, style);
  //   // style.fontFamily = "Poppins_700Bold"
  // }


  

  return (
    <ReactText {...props} style={[style, propsStyle]} />
  )
}